import React from 'react';
import PropTypes from 'prop-types';
import './DesktopNavBar.css';
import { ConnectedDesktopNavBarCategory } from '../DesktopNavBarCategory';
import { ConnectedLogoutButton } from '../LogoutButton';
import { HELP_CATEGORY, ACCOUNT_CATEGORY, SETTINGS_CATEGORY } from '../NavBar/navConstants';

export const DesktopNavBar = (props) => {
  const {
    navigation,
    navigationParams: { selectedCategory, selectedSubCategory },
    isUserManager,
  } = props;

  return (
    <div className="nav-bar-list-desktop">
      <ul className="nav-bar-list">
        {navigation.map((category) => (
          <ConnectedDesktopNavBarCategory
            key={category.id}
            isSelected={selectedCategory.id === category.id}
            category={category}
            selectedSubCategory={selectedSubCategory}
            subCategories={category.sub_categories}
          />
        ))}
      </ul>
      <ul>
        <ConnectedDesktopNavBarCategory
          isSelected={selectedCategory.id === 'account'}
          category={ACCOUNT_CATEGORY}
          selectedSubCategory={selectedSubCategory}
          subCategories={ACCOUNT_CATEGORY.sub_categories}
        />
        {isUserManager ? (
          <ConnectedDesktopNavBarCategory
            isSelected={selectedCategory.id === 'settings'}
            category={SETTINGS_CATEGORY}
            selectedSubCategory={selectedSubCategory}
            subCategories={SETTINGS_CATEGORY.sub_categories}
          />
        ) : null}
        <ConnectedDesktopNavBarCategory
          isSelected={selectedCategory.id === 'Help'}
          category={HELP_CATEGORY}
          selectedSubCategory={selectedSubCategory}
        />
        <ConnectedLogoutButton />
      </ul>
    </div>
  );
};

DesktopNavBar.propTypes = {
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      selectedCategory: PropTypes.shape({
        id: PropTypes.string,
        image: PropTypes.string,
        name: PropTypes.string,
        sub_categories: PropTypes.arrayOf(
          PropTypes.shape({
            api_location: PropTypes.string,
            data_api_location: PropTypes.string,
            id: PropTypes.string,
            url: PropTypes.string,
            name: PropTypes.string,
          }),
        ),
        api_location: PropTypes.string,
        url: PropTypes.string,
      }),
    }).isRequired,
  ),
  navigationParams: PropTypes.shape({
    selectedCategory: PropTypes.shape({
      id: PropTypes.string,
      image: PropTypes.string,
      name: PropTypes.string,
      sub_categories: PropTypes.array,
      api_location: PropTypes.string,
      url: PropTypes.string,
    }),
    selectedSubCategory: PropTypes.shape({
      api_location: PropTypes.string,
      data_api_location: PropTypes.string,
      id: PropTypes.string,
      url: PropTypes.string,
      name: PropTypes.string,
    }),
  }).isRequired,
  isStaff: PropTypes.bool.isRequired,
  isUserManager: PropTypes.bool.isRequired,
};

DesktopNavBar.defaultProps = {
  navigation: [],
  navigationParams: {},
  isStaff: false,
  isUserManager: false,
};
